
(function (window, document, jQuery, undefined) {    
    $('.kit-accordeon-widget').each(function () {
        var $accordeonElement = $(this);
        var allCollapseElements = $accordeonElement.find(".collapse");

        // Add minus icon for collapse element which is open by default
        $accordeonElement.find(".collapse.show").each(function () {
            $(this)
                .prev(".kit-accordeon-widget__header-link")
                .find(".fa")
                .addClass("fa-minus")
                .removeClass("fa-plus");
        });

        // Toggle plus minus icon on show hide of collapse element
        allCollapseElements
            .on('show.bs.collapse', function () {
                $(this)
                    .prev(".kit-accordeon-widget__header-link")
                    .find(".fa")
                    .removeClass("fa-plus")
                    .addClass("fa-minus");
            })
            .on('hide.bs.collapse', function () {
                $(this)
                    .prev(".kit-accordeon-widget__header-link")
                    .find(".fa")
                    .removeClass("fa-minus")
                    .addClass("fa-plus");
            });
    });
})(window, document, jQuery);
